import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import StyleConfig from "src/constants/StyleConfig";
import { formatDate, isSameDay } from "src/helpers/UtilityHelper";
import InputAutoSuggest from "src/components/atoms/form/InputAutoSuggest";
import RadioBox from "src/components/atoms/form/RadioBox";

interface Props {
  suggestions: string[];
  query: string;
  lastPickupDays: Date[];
  currentDate: Date;
  filterByStatus: string;
  onChangeQuery: (text: string) => void;
  onSuggestionsFetchRequested: (text: string) => void;
  onSuggestionsClearRequested: () => void;
  onSuggestionSelected: (text: string) => void;
  onChangeFilterByStatus: (value: string) => void;
  onChangeCurrentDate: (date: Date) => void;
}

const ReservationOrderDetailFilterForm = ({ ...props }: Props) => {
  const {
    suggestions,
    query,
    lastPickupDays,
    currentDate,
    filterByStatus,
    onChangeQuery,
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    onSuggestionSelected,
    onChangeFilterByStatus,
    onChangeCurrentDate,
  } = props;

  return (
    <Filter>
      <div className="first">
        <Search>
          <div className="search-input">
            <InputAutoSuggest
              suggestions={suggestions}
              inputType={"search"}
              inputValue={query}
              onChange={onChangeQuery}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              onSuggestionSelected={onSuggestionSelected}
              placeholder={"受取番号/注文者検索"}
            />
          </div>
        </Search>
        <LabeledChoise>
          <Label>表示する商品を切り替える</Label>
          <RadioGroup>
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"準備する商品を表示"}
              isChecked={filterByStatus === "準備する商品を表示"}
              onChange={onChangeFilterByStatus}
            />
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"準備済の商品を表示"}
              isChecked={filterByStatus === "準備済の商品を表示"}
              onChange={onChangeFilterByStatus}
            />
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"受渡済の商品を表示"}
              isChecked={filterByStatus === "受渡済の商品を表示"}
              onChange={onChangeFilterByStatus}
            />
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"すべての商品を表示"}
              isChecked={filterByStatus === "すべての商品を表示"}
              onChange={onChangeFilterByStatus}
            />
          </RadioGroup>
        </LabeledChoise>
      </div>
      <div className="second">
        <div className="days">
          {lastPickupDays.map((v, i) => (
            <button
              className={`day ${
                isSameDay(currentDate, v) ? "is-selected" : ""
              }`}
              key={`ReservationOrderDetailFilterForm|days|${i}`}
              onClick={() => onChangeCurrentDate(v)}
            >
              {formatDate(v, "YYYY年MM月DD日(ddd)")}
            </button>
          ))}
        </div>
      </div>
    </Filter>
  );
};

const Filter = styled.div`
  .first {
    display: block;
    border-bottom: 1px solid #9a9a9a;
    margin-bottom: 20px;
    padding-bottom: 20px;
    ${media.greaterThan("medium")`
      flex-wrap: nowrap;
    `};
  }

  .second {
    overflow-x: scroll;

    .days {
      padding-bottom: 30px;
      overflow-x: scroll;
      flex-wrap: nowrap;
      display: inline-flex;
      justify-content: flex-start;
      align-items: center;
      .day {
        width: 140px;
        font-size: 14px;
        margin-right: 24px;
        padding: 2px 1px 2px 0;
        border-bottom: 1px solid ${StyleConfig.COLOR.TEXT_COLOR};

        ::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 7px;
        }
        ::-webkit-scrollbar-thumb {
          border-radius: 4px;
          background-color: rgba(0, 0, 0, 0.5);
          box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
        }

        &.is-selected {
          font-weight: bold;
          border-bottom: none;
          cursor: text;
        }
      }
    }
  }
`;

const Search = styled.div`
  width: 100%;
  display: flex;

  ${media.greaterThan("medium")`
    width: auto;
    flex: 1;
  `};

  .search-input {
    flex-grow: 2;

    input {
      border: none;
      border-radius: 4px;
    }
  }
`;

const LabeledChoise = styled.div`
  margin-top: 12px;
`;

const Label = styled.label`
  color: ${StyleConfig.COLOR.PRIMARY};
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
`;

const RadioGroup = styled.div`
  label {
    margin-top: 8px;
    input {
      width: 17px;
      height: 17px;
      border: 1px solid #cfcfd2;
    }
    input:after {
      width: 64%;
      height: 64%;
    }
    span {
      font-size: 12px;
    }
  }
`;

export default ReservationOrderDetailFilterForm;
